import React from 'react';
import PropTypes from 'prop-types';
import Grid, { GridItem } from '@marvelapp/marvel-ui/grid';
import PageWrap from '@marvelapp/marvel-ui/page-wrap';
import Spacing from '@marvelapp/marvel-ui/spacing';

import Image from 'marketing-website/components/modules/Image';
import HeadingBlock from 'marketing-website/components/modules/HeadingBlock';
import MediaMultipleImages from 'marketing-website/components/modules/Media/MediaMultipleImages';
import ParallaxWrapper from 'marketing-website/components/wrappers/ParallaxWrapper';
import Pattern from 'marketing-website/components/commons/Pattern';
import Shape from 'marketing-website/components/commons/Shape';

import assets from 'marketing-website/configs/pages/features/wireframing/assets.js';

export default function MobileBlock({ color }) {
  return (
    <PageWrap size="l">
      <Spacing size="0" sizeM="xl" type="padding" position="topBottom">
        <Grid columns={12}>
          <GridItem columnSpan={12} columnSpanM={7} alignContent="center">
            <MediaMultipleImages
              fallbackImageAlt={assets.wireframeFallbackRetina.alt}
              fallbackImageSrc={assets.wireframeFallbackRetina.src}
              fallbackImageMaxWidth={assets.wireframeFallbackRetina.maxWidth}
            >
              <Shape type="square" color={color} width={426} height={375} />
              <ParallaxWrapper speed={1}>
                <Pattern
                  color="purple"
                  left="auto"
                  right="22%"
                  top="26%"
                  type="shortRectangle"
                />
              </ParallaxWrapper>
              <ParallaxWrapper speed={1}>
                <Pattern
                  bottom="30%"
                  color="purple"
                  left="22%"
                  top="auto"
                  type="shortRectangle"
                />
              </ParallaxWrapper>
              <ParallaxWrapper speed={0.8}>
                <Image
                  {...assets.watchOne}
                  left="15%"
                  maxWidth={159}
                  position="absolute"
                  top="30%"
                />
              </ParallaxWrapper>
              <ParallaxWrapper speed={1}>
                <Image
                  {...assets.watchTwo}
                  right="13%"
                  maxWidth={168}
                  position="absolute"
                  top="43%"
                />
              </ParallaxWrapper>
              <ParallaxWrapper speed={2}>
                <Image
                  {...assets.wireframe}
                  right="29%"
                  maxWidth={312}
                  position="absolute"
                  bottom="10%"
                />
              </ParallaxWrapper>
            </MediaMultipleImages>
          </GridItem>
          <GridItem columnSpan={12} columnSpanM={5} alignContent="center">
            <HeadingBlock
              justifyContent="center"
              alignContent="center"
              maxWidth={420}
              title="Wireframe for any device"
              copy={
                <span>
                  Go from idea to wireframe within minutes for any device,
                  iPhone, iPad, Android and desktop.
                  <br />
                  <br />
                  Perfect for the early stages of the design process when you’re
                  trying to form your concept into something tangible and
                  translate it to your team, clients or stakeholders.
                </span>
              }
            />
          </GridItem>
        </Grid>
      </Spacing>
    </PageWrap>
  );
}

MobileBlock.propTypes = {
  color: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./src/pages/features/wireframing/MobileBlock.js